export default __webpack_public_path__ + "static/elch_logo-64ac8ba136667b6395de24300a0f59bf.svg";